<template>
  <div>
    <div class="retrun_top_app" style="display: flex">
      <div class="cus" @click.stop="openCare">
        <img src="@/assets/appimg/common/cus.svg" />
      </div>
      <div class="top" v-if="backupShow" @click.stop="backToTop">
        <img src="@/assets/appimg/common/top2.svg" />
      </div>
    </div>
    <CustCare ref="consultRef" />
  </div>
</template>
<script>
import scrollToTop from '@/mixins/scrollToTop'
import CustCare from '@/views/app/components/custCare'
export default {
  name: 'ReturnTopApp',
  mixins: [scrollToTop],
  components: { CustCare },
  methods: {
    openCare() {
      this.$refs.consultRef.open()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/components/returnTop.vue